import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { routePaths } from '@/shared/config/site'

type SiteFooterProps = {
  pathnameOverride?: string
}

export function SiteFooter({ pathnameOverride }: SiteFooterProps = {}) {
  const currentPathname = usePathname()
  const pathname = pathnameOverride ?? currentPathname ?? ''

  if (
    pathname === routePaths.terms ||
    pathname === '/prompting-guide' ||
    pathname.startsWith('/admin') ||
    pathname.startsWith('/chat')
  ) {
    return null
  }

  return (
    <footer className="print-hidden border-t border-[var(--border)] bg-background px-5 py-6 md:px-8 lg:px-10">
      <div className="mx-auto flex max-w-6xl justify-end">
        <Link
          className="text-sm text-whisper-blue underline-offset-4 hover:text-comet hover:underline"
          href={routePaths.terms}
        >
          {'Terms'}
        </Link>
      </div>
    </footer>
  )
}
